// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5ceebb69] .el-dialog__body {\n  padding: 10px 10px;\n  height: 440px;\n  overflow: auto;\n}\n[data-v-5ceebb69] .el-dialog__body .pic-tip {\n  color: #999;\n  font-size: 12px;\n  height: 12px;\n  -webkit-transform: translate(5px, -30px);\n          transform: translate(5px, -30px);\n}\n.el-form-item--mini.el-form-item[data-v-5ceebb69] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
